import { useSelector } from "react-redux";
import { StaffListConstants } from "../../constants/constants";
import { RootState } from "../../store/store";

export const StaffListTitle = () => {
  const userDetail = useSelector((state: RootState) => state.userDetails.user); // Access userDetail from Redux store

  return (
    <div className="flex flex-col">
      <div className="text" style={{ fontFamily: "Poppins" }}>{StaffListConstants.Title}</div>
      <div className="text-primary flex staffListDownloadCheckbox font-nunito">
        <div>{StaffListConstants.StaffListBreadCrumb} </div>
        <div> {`${userDetail?.firstName ?? ""} Profile`}</div>
      </div>
    </div>
  );
};
